import { useQuery } from '@tanstack/react-query';
import { Badge, Card } from 'corso-admin-ui';
import api from '~/api';
import { useProduct } from '~/features/products/ProductProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function ProductRegistrationChannels() {
  const { id } = useProduct();
  const storeId = useStoreId();

  const { data: channels, isPending } = useQuery({
    queryKey: ['product', id, 'registrationChannels', storeId],
    queryFn: () => api.store(storeId).product.registrationChannels(`${id}`),
  });

  if (isPending || !channels?.length) return null;

  return (
    <Card>
      <Card.Line>
        <Card.Heading>Registration Channels</Card.Heading>
      </Card.Line>

      <div className="flex flex-wrap gap-1">
        {channels.map((channel) => (
          <Badge key={channel.id}>{channel.name}</Badge>
        ))}
      </div>
    </Card>
  );
}
